export default __webpack_public_path__ + "static/media/gournaymini.be0d159f.jpg";